module.exports = __webpack_public_path__ + "img/ALL.6fdf981e.png";